import React, { useState } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Container, Box } from '@mui/material';
import FileUpload from './components/FileUpload';
import AccountDisplay from './components/AccountDisplay';
import SplashSection from './components/SplashSection';
import BalanceTrend from './components/BalanceTrend';
import TransactionTable from './components/TransactionTable';

const App = () => {
    const [parsedData, setParsedData] = useState(null);
    const [filteredTransactions, setFilteredTransactions] = useState(null); // Filtered transactions state

    const theme = createTheme({
        palette: {
            primary: { main: '#1976d2' },
            secondary: { main: '#dc004e' },
        },
        typography: {
            fontFamily: 'Roboto, Arial, sans-serif',
        },
    });

    // Handle filtering transactions by month
    const handleMonthClick = (startDate, endDate) => {
        if (parsedData && parsedData.transactions) {
            const filtered = parsedData.transactions.filter((transaction) => {
                const transactionDate = new Date(transaction.date_posted);
                return transactionDate >= new Date(startDate) && transactionDate <= new Date(endDate);
            });
            setFilteredTransactions(filtered);
        }
    };

    return (
        <ThemeProvider theme={theme}>
            <Container maxWidth="lg" sx={{ marginTop: '20px', padding: '20px 0' }}>
                {/* Splash Section */}
                <SplashSection />

                {/* File Upload Section */}
                <Box
                    sx={{
                        textAlign: 'center',
                        padding: '20px',
                        backgroundColor: '#fff',
                        border: '1px solid #ddd',
                        borderRadius: '8px',
                        marginBottom: '40px',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    }}
                >
                    <FileUpload setParsedData={setParsedData} />
                </Box>

                {/* Account Display Section */}
                {parsedData && (
                    <>
                        {/* Balance Trend Chart */}
                        <BalanceTrend
                            averageMonthlyBalances={parsedData.accounts[0]?.balances?.average_monthly_balances || []}
                            onMonthClick={handleMonthClick}
                        />

                        {/* Transactions Table */}
                        <TransactionTable
                            transactions={filteredTransactions || parsedData.transactions}
                        />
                    </>
                )}
            </Container>
        </ThemeProvider>
    );
};

export default App;

